//@flow
import {update} from 'lodash'
import {select, put, call} from 'redux-saga/effects'

import {type StoreState} from '$src/state/types'

type SetStateType = <StateChunk>(
  path: Array<*> | string | number,
  reducer: (state: StateChunk) => StateChunk
) => {}

const setState: SetStateType = (path, reducer) => {
  const effect: {} = call(function*(): Generator<> {
    const state: StoreState = yield select()
    const updatedState: StoreState = update({...state}, path, reducer)

    yield put({type: 'GENERIC/SET_STATE', payload: updatedState})
  })
  return effect
}

export default setState



// WEBPACK FOOTER //
// ./src/util/setState.js